<template>
  <a
    :href="link"
    target="_blank"
    rel="noopener"
    class="winners-2021-winners-card-winner-stand"
  >
    <img
      src="@/assets/img/winners/2021/beams.png"
      alt=""
      class="winners-2021-winners-card-winner-stand__beams"
    />
    <Winners2021Stand
      :src="user.avatar"
      :alt="user.nickname"
      class="winners-2021-winners-card-winner-stand__img"
    />
    <div class="winners-2021-winners-card-winner-stand__name orange">
      {{ user.nickname }}
    </div>
  </a>
</template>

<script>
import Winners2021Stand from "./Winners2021Stand";

export default {
  name: "Winners2021PlaceWinnersCardWinnerStand",
  components: {
    Winners2021Stand
  },
  props: {
    user: {
      type: Object,
      required: false
    }
  },
  computed: {
    link() {
      const { user } = this;
      return (
        (user &&
          user.steam_id64 &&
          `https://steamcommunity.com/profiles/${user.steam_id64}/`) ||
        null
      );
    }
  }
};
</script>

<style lang="scss">
.winners-2021-winners-card-winner-stand {
  position: relative;
  z-index: 1;

  display: flex;
  flex-direction: column;
  align-items: center;

  text-align: center;

  margin-bottom: 25px;

  &__beams {
    position: absolute;
    z-index: -1;
    left: 50%;
    top: -30px;
    transform: translateX(-50%);
    width: 350px;
    height: 350px;
    pointer-events: none;
  }

  &__img {
    margin-bottom: 20px;

    width: 230px;
    height: 195px;

    filter: drop-shadow(0 15px 20px #141c33);

    .winners-2021-stand-img {
      width: 145px;
      height: 145px;
      top: 35px;
      left: 44px;
    }
  }

  &__name {
    font-size: 18px;
    font-weight: 800;
    position: relative;
  }

  @include breakpoint("xs-only") {
    &__name {
      font-size: 16px;
    }
    &__beams {
      width: 280px;
      height: 280px;
    }
    &__img {
      margin-bottom: 15px;

      width: 220px;
      height: 185px;

      .winners-2021-stand-img {
        width: 135px;
        height: 135px;
        top: 30px;
        left: 44px;
      }
    }
  }
}
</style>
